import { checkDocumentsFetching, getDocumentsData } from "selectors/documents";
import { useCallback, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Async from "utils/Async";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import DocumentsActions from "actions/DocumentsActions";
import useEnvVars from "hooks/useEnvVars";

const useDocuments = ({ status: statusFromProps } = {}) => {
  const dispatch = useDispatch();

  const fetching = useSelector(checkDocumentsFetching);

  const data = useSelector(getDocumentsData);

  const [envVars] = useEnvVars();

  const prevStatus = useRef(true);

  const {
    pageSize = Constants.TABLE_PAGE_SIZE,
    status = statusFromProps,
    page = 1,
    text,
    type,
    sortBy,
    toDate,
    paidWith,
    fromDate,
    sortOrder,
    createdBy,
    createdAt
  } = envVars;

  const hasFilters = !![text, fromDate, toDate, type].find(Boolean);

  const fetchData = useCallback(async(backgroundUpdate = false) => {
    prevStatus.current = status;

    const paidStatus = ["paid", "unpaid"].includes(status);

    const result = await dispatch(DocumentsActions.fetchDocumentsList({
      status: paidStatus ? DataStatuses.EXPORTED : status,
      paid: paidStatus ? status === "paid" : undefined,
      filters: { fromDate, toDate, text, paymentType: type, createdBy, createdAt, paidWith },
      sortings: sortBy ? { id: sortBy, desc: sortOrder === "desc" } : null,
      offset: (page - 1) * pageSize,
      limit: Number(pageSize),
      backgroundUpdate
    }));

    return result;
  }, [
    dispatch,
    status,
    fromDate,
    toDate,
    text,
    type,
    sortBy,
    paidWith,
    sortOrder,
    pageSize,
    createdBy,
    createdAt,
    page
  ]);

  const refetch = useCallback((backgroundUpdate) => {
    return fetchData(backgroundUpdate);
  }, [fetchData]);

  useLayoutEffect(() => {
    fetchData();

    return Async.setInterval(
      () => fetchData(true), Constants.DATA_LIST_UPDATE_INTERVAL
    );
  }, [fetchData]);

  return {
    fetching,
    hasFilters,
    data,
    refetch
  };
};

export default useDocuments;
